(function () {

    "use strict";

    var dependencies = ['$q', 'Upload', 'hUser', 'onBoardingService'];

    function EmploymentReverificationForm(formName) {

        var self = this;
        var $q = dependencies.$q;
        var hUser = dependencies.hUser;
        var Upload = dependencies['Upload'];
        const onBoardingService = dependencies['onBoardingService'];

        self.documentsTitlesList = OnBoardingAPI.DOCUMENT_CODES_TITLES;
        self.now = moment();

        var _referenceI9DocumentId;
        var _prospectId;

        self.load = function (brandId, i9EmployerExcludeAttachments, OBIdObj, referenceI9Document, i9ReverificationDocument, employerPreFillingEnabled) {
            var defer = $q.defer();
            _prospectId = OBIdObj.prospect_id;

            self.brandId = brandId;
            self.i9EmployerExcludeAttachments = i9EmployerExcludeAttachments;
            self.i9Attachments = getDocumentsTitles();
            self.data = {candidate: {personal_information: {}}};

            if (i9ReverificationDocument && i9ReverificationDocument.meta_data) {
                self.data = {
                    candidate: {
                        personal_information: {
                            first_name: i9ReverificationDocument.meta_data.new_first_name || i9ReverificationDocument.meta_data.candidate.personal_information.first_name,
                            middle_initial: i9ReverificationDocument.meta_data.new_middle_name || i9ReverificationDocument.meta_data.candidate.personal_information.middle_initial,
                            last_name: i9ReverificationDocument.meta_data.new_last_name || i9ReverificationDocument.meta_data.candidate.personal_information.last_name
                        }
                    }
                };
            }

            if (referenceI9Document) {
                _referenceI9DocumentId = referenceI9Document.id;

                if (referenceI9Document.meta_data) {
                    if (self.data && self.data.candidate && self.data.candidate.personal_information) {
                        self.data.candidate.personal_information.first_name = self.data.candidate.personal_information.first_name || referenceI9Document.meta_data.personal_information.first_name;
                        self.data.candidate.personal_information.middle_initial = self.data.candidate.personal_information.middle_initial || referenceI9Document.meta_data.personal_information.middle_initial;
                        self.data.candidate.personal_information.last_name = self.data.candidate.personal_information.last_name || referenceI9Document.meta_data.personal_information.last_name;
                    } else {
                        self.data = {
                            candidate: {
                                personal_information: referenceI9Document.meta_data.personal_information
                            }
                        };
                    }
                }
            }

            if (self.data.candidate && self.data.candidate.personal_information) {
                self.firstNameLoadedFromExistingDoc = !!self.data.candidate.personal_information.first_name;
                self.middleNameLoadedFromExistingDoc = !!self.data.candidate.personal_information.middle_initial;
                self.lastNameLoadedFromExistingDoc = !!self.data.candidate.personal_information.last_name;
            }

            if (employerPreFillingEnabled) {
                self.data.candidate.personal_information.first_name = self.data.candidate.personal_information.first_name || OBIdObj.first_name;
                self.data.candidate.personal_information.last_name = self.data.candidate.personal_information.last_name || OBIdObj.last_name;
            } else {
                delete self.data.candidate.personal_information.first_name;
                delete self.data.candidate.personal_information.middle_initial;
                delete self.data.candidate.personal_information.last_name;
                self.firstNameLoadedFromExistingDoc = false;
                self.middleNameLoadedFromExistingDoc = false;
                self.lastNameLoadedFromExistingDoc = false;
            }

            if (i9ReverificationDocument && i9ReverificationDocument.meta_data && i9ReverificationDocument.meta_data.personal_information) {
                self.data.personal_information = {
                    first_name: i9ReverificationDocument.meta_data.personal_information.first_name || hUser.data.user.first_name,
                    last_name: i9ReverificationDocument.meta_data.personal_information.last_name || hUser.data.user.last_name
                };

            } else {
                self.data.personal_information = {
                    first_name: hUser.data.user.first_name,
                    last_name: hUser.data.user.last_name
                };
            }

            OnBoardingAPI.getAttachmentCodeLookup()
                .then(function () {
                    defer.resolve();
                });

            return defer.promise;
        };

        self.showBackCardAttachment = function () {
            return (
                self.data.attachment_document && (
                    self.data.attachment_document.code == 'EMP_AUTH_DOC' ||
                    self.data.attachment_document.code == 'US_PASSPORT' ||
                    self.data.attachment_document.code == 'US_PASSPORT_CARD' ||
                    self.data.attachment_document.code == 'PERM_RESID_CARD'
                )
            );
        };

        var getBackCardCode = function (frontCode) {

            switch (frontCode) {
                case 'EMP_AUTH_DOC':
                    return 'EMP_AUTH_DOC_BACK';
                case 'US_PASSPORT':
                    return 'US_PASSPORT_BACK';
                case 'US_PASSPORT_CARD':
                    return 'US_PASSPORT_CARD_BACK';
                case 'PERM_RESID_CARD':
                    return 'PERM_RESID_CARD_BACK';
                default:
                    return '';
            }
        };

        self.docTitleUpdated = function () {
            if (self.data.attachment_document) {
                if (self.selectedFile) {
                    self.selectedFile.code = self.data.attachment_document.code;
                    self.selectedFile.name = OnBoardingAPI.DOCUMENT_CODES_TITLES[self.data.attachment_document.code];
                }

                if (self.selectedBackFile) {
                    var backCode = getBackCardCode(self.data.attachment_document.code);

                    self.selectedBackFile.code = backCode;
                    self.selectedBackFile.name = OnBoardingAPI.DOCUMENT_CODES_TITLES[backCode];
                }
            }
        };

        self.selectAttachment = function (file, attachType) {
            if (file) {
                var fileType = Utils.getFileType(file);

                if (fileType.indexOf("image/") > -1 || fileType.indexOf("/pdf") > -1) {
                    if (attachType == 'BACK') {
                        var backCode = getBackCardCode(self.data.attachment_document.code);
                        self.selectedBackFile = {
                            file: file,
                            progress: 100,
                            code: backCode,
                            name: self.data.attachment_document && OnBoardingAPI.DOCUMENT_CODES_TITLES[backCode]
                        };

                    } else {
                        self.selectedFile = {
                            file: file,
                            progress: 100,
                            code: self.data.attachment_document && self.data.attachment_document.code,
                            name: self.data.attachment_document && OnBoardingAPI.DOCUMENT_CODES_TITLES[self.data.attachment_document.code]
                        };
                    }

                    self.missingAttachment = false;
                } else {
                    hAlert($filter("translate")("Invalid Attachment"), $filter("translate")("Attachment document should be image or PDF file."));
                }
            }
        };

        self.unselectAttachment = function (attachType) {
            if (attachType == 'BACK') {
                delete self.selectedBackFile;
            } else {
                delete self.selectedFile;
            }
        };

        var uploadAttachment = function (file, docId) {
            var defer = $q.defer();

            var uploadUrl = file.id ? `${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}attachment/${file.id}` : `${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}attachment`;
            var uploadMethod = 'PUT';

            var attachmentCode = OnBoardingAPI.attachmentCodeLookup[file.code] || {};

            var data = {
                document_id: docId,
                custom_name: attachmentCode.name || OnBoardingAPI.DOCUMENT_CODES_TITLES[file.code] || file.name,
                attachment_file: file.file
            };

            if (attachmentCode.id) {
                data['attachment_code_lookup_id'] = attachmentCode.id;
            }

            Upload.upload({
                url: uploadUrl,
                withCredentials: true,
                headers: {},
                method: uploadMethod,
                data: data
            }).progress(function (evt) {
                var uploaded = evt.loaded || 0;
                var total = evt.total;
                file.progress = 100 * uploaded / total;
            }).success(function (res, status, headers, config) {

                if (res.status_code == 200) {
                    defer.resolve(res);
                }
                else {
                    defer.reject(res);
                }

            }).error(function (err) {
                console.log(err);
                defer.reject(data);
            });

            return defer.promise;
        };

        self.save = function () {
            var defer = $q.defer();

            self.validator.validate(function (isValid) {
                self.missingAttachment = (
                    !self.i9EmployerExcludeAttachments &&
                    (!self.selectedFile || (self.showBackCardAttachment() && !self.selectedBackFile))
                );

                if (isValid && !self.missingAttachment) {
                    var document = {
                        metadata: self.data,
                        code: OnBoardingAPI.DOCUMENT_TYPE.I9_REVERIFICATION_SECTION_3
                    };

                    var prospect = {
                        prospect_id: _prospectId
                    };

                    if (_referenceI9DocumentId) {
                        prospect['referenced_documents'] = [
                            {
                                lookup_code: OnBoardingAPI.DOCUMENT_TYPE.I9_REVERIFICATION_SECTION_3,
                                reference_document_id: _referenceI9DocumentId
                            }
                        ];
                    }

                    onBoardingService.sendDocuments(prospect, [document], "MY_TEAM_DOCS")
                        .then(function (result) {
                            var sentDoc = result['sent'] && result['sent'][0] || {};

                            if (self.i9EmployerExcludeAttachments) {
                                defer.resolve(result);
                            } else {
                                var promises = [];

                                promises.push(uploadAttachment(self.selectedFile, sentDoc.id));

                                if (self.showBackCardAttachment() && self.selectedBackFile) {
                                    promises.push(uploadAttachment(self.selectedBackFile, sentDoc.id));
                                }

                                $q.all(promises)
                                    .then(function (res) {
                                        defer.resolve(result);
                                    }, function (err) {
                                        console.error(err);
                                        defer.reject(err);
                                    });
                            }
                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });

                }
                else {
                    defer.reject();
                }
            });

            return defer.promise;
        };

        self.onDocumentChanged = function () {
            var documentsList = getDocumentsTitles();

            for (var i in documentsList) {
                if (documentsList[i].code === self.data.attachment_document.code) {
                    self.data.attachment_document = documentsList[i];
                    break;
                }
            }
        };

        var getDocumentsTitles = function () {
            var documentAttachments = [];

            for (var code in self.documentsTitlesList) {
                var documentTitle = self.documentsTitlesList[code];
                var documentObj = {};

                switch (code) {
                    case 'RECEIPT_PERM_RESID_CARD':
                    case 'RECEIPT_FSM_PASSPORT':
                    case 'RECEIPT_RIM_PASSPORT':
                    case 'RECEIPT_REPLACEMENT_BIRTH_CERTIFICATE':
                    case 'RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL':
                    case 'RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS':
                    case 'RECEIPT_I_94':
                    case 'RECEIPT_I_94_REFUGEE':
                    case 'ALIEN_PERM_RESID_CARD':
                    case 'RECEIPT_REPLACEMENT_FOREIGN_PASSPORT_Form_I_94':
                    case 'RECEIPT_REPLACEMENT_SOCIAL_SECURITY_CARD':
                    case 'RECEIPT_REPLACEMENT_EMP_AUTH_DOC':
                        documentObj['receipt'] = true;
                    case 'US_PASSPORT':
                    case 'US_PASSPORT_CARD':
                    case 'PERM_RESID_CARD':
                    case 'FOREIGN_PASSPORT_TEMP_STAMP':
                    case 'FOREIGN_PASSPORT_TEMP_MRIV':
                    case 'EMP_AUTH_DOC':
                    case 'FOREIGN_PASSPORT_Form_I_94':
                    case 'FSM_PASSPORT':
                    case 'RIM_PASSPORT':
                    case 'SOCIAL_SECURITY_CARD_UNRESTRICTED':
                    case 'FORM_FS_545':
                    case 'FORM_DS_1350':
                    case 'CONSULAR_REPORT_OF_BIRTH_ABROAD':
                    case 'US_BRITH_CERTIFICATE':
                    case 'NATIVE_AMERICAN_TRIPLE_DOC':
                    case 'FORM_I_197':
                    case 'FORM_I_179':
                    case 'EMPLOYMENT_AUTH_DHS':
                        documentObj['code'] = code;
                        documentObj['title'] = documentTitle;
                        documentAttachments.push(documentObj);
                        break;
                }

            }

            return documentAttachments;
        };


    }

    angular
        .module("harriMainApp")
        .run(['hFormsService', function (hFormsService) {

            hFormsService.registerForm("employmentReverificationForm", {
                form: EmploymentReverificationForm,
                dependencies: dependencies
            });
        }]);
})();
